import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalService } from 'ng-devui';
import { catchError, map, Observable, throwError } from 'rxjs';
import {
  AlertDialogComponent,
  AlertDialogType,
} from '../../components/alert-dialog/alert-dialog.component';
import { GlobalService } from '../global.service';
import { Response } from './respponse.type';

@Injectable({
  providedIn: 'root',
})
export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private globalService: GlobalService,
    private modalService: ModalService,
  ) {}

  timeout: any;

  intercept<T>(
    request: HttpRequest<Response<T>>,
    next: HttpHandler,
  ): Observable<HttpEvent<T>> {
    const hasReindex = request.url.includes('/reindex');
    let authReq = this.globalService.isLogin
      ? request.clone({
          setHeaders: hasReindex
            ? {
                token: this.globalService.token,
                adminPassword: 'RF20240513xmdm@',
              }
            : {
                token: this.globalService.token,
              },
        })
      : request;

    return next.handle(authReq).pipe(
      map((event) => {
        if (
          event instanceof HttpResponse &&
          event.url &&
          !event.url.includes('download')
        ) {
          let response = event.body as Response<T>;
          if (!response.success) {
            this.handleBusinessError(response);
          }
          return event.clone({ body: response.data ? response.data : null });
        }
        return event;
      }),
      catchError((err) => this.handleNetworkError(err)),
    );
  }

  private handleBusinessError(response: Response<any>) {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.timeout = setTimeout(() => {
      console.log('handleBusinessError', response);
      const results = this.modalService.open({
        backdropCloseable: false,
        component: AlertDialogComponent,
        onClose: () => {},
        data: {
          title: '请求失败',
          content:
            response.message === 'token无效' || response.message === 'token为空'
              ? '登录已过期，请重新登录'
              : response.message,
          cancelBtnText: '确认',
          confirmBtnText: '确认',
          contentStyle: 'danger',
          type: AlertDialogType.simple,
          onCancel: () => {
            results.modalInstance.hide();
          },
          onConfirm: () => {
            results.modalInstance.hide();
          },
        },
      });
      if (response.message === 'token无效') {
        this.globalService.logout();
      }
    }, 100);
  }

  private handleNetworkError(error: HttpErrorResponse) {
    if (error.status === 0) {
      const results = this.modalService.open({
        backdropCloseable: false,
        component: AlertDialogComponent,
        onClose: () => {},
        data: {
          title: '网络错误',
          content: '无法和服务器连接，请检查网络是否正常',
          cancelBtnText: '确认',
          confirmBtnText: '确认',
          contentStyle: 'danger',
          type: AlertDialogType.simple,
          onCancel: () => {
            results.modalInstance.hide();
          },
          onConfirm: () => {
            results.modalInstance.hide();
          },
        },
      });
    } else {
      const results = this.modalService.open({
        backdropCloseable: false,
        component: AlertDialogComponent,
        onClose: () => {},
        data: {
          title: `${error.status}`,
          content: error.error || '无法和服务器连接，请检查网络是否正常',
          cancelBtnText: '确认',
          confirmBtnText: '确认',
          contentStyle: 'danger',
          type: AlertDialogType.simple,
          onCancel: () => {
            results.modalInstance.hide();
          },
          onConfirm: () => {
            results.modalInstance.hide();
          },
        },
      });
    }
    return throwError('Something bad happened; please try again later.');
  }
}
